import React from 'react'

import { Absolute, Relative } from '../../../../components/pdf/Position'
import { getFieldInPx } from '../_helpers/fieldInPixels'
import { usePdfOptionsForm } from '../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Grid from '../../../../components/pdf/Grid'
import Image from '../../../../components/pdf/Image'
import Qrcode from '../../../../containers/qrcodes/Qrcode'
import View from '../../../../components/pdf/View'

const Template = ({ qrcode }) => {
  const form = usePdfOptionsForm()
  const Template = form.Component

  const defaultCSS = {
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "SF Pro Display", "Nunito", "Montserrat", sans-serif',
    lineHeight: '110%',
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    backgroundColor: '#FFFFFF'
  }

  if (Template) return <Template qrcode={qrcode} />

  return (
    <Relative>
      <Absolute top={getFieldInPx(form, 'qrcodeTop')} left={getFieldInPx(form, 'qrcodeLeft')} zIndex="10000">
        <Qrcode qrcode={qrcode} size={getFieldInPx(form, 'qrcodeSize')} />
        {form.activationDetails && qrcode?.data?.name && (
          <div
            style={{
              ...defaultCSS,
              fontSize: getFieldInPx(form, 'qrcodeSize') / 19,
              width: getFieldInPx(form, 'qrcodeSize')
            }}
          >
            {qrcode?.data?.name?.toUpperCase()}
          </div>
        )}
      </Absolute>
      <Image width={form.templateWidth + 'cm'} height="auto" maxWidth="none" src={form.svgTemplate?.preview} />
    </Relative>
  )
}

const QrcodeWithTemplate = ({ qrcode }) => {
  return (
    <View pageBreakAfter noWrap width="500mm">
      <Grid justify="center" direction="column" style={{ padding: '5px' }}>
        <Template qrcode={qrcode} />
      </Grid>
    </View>
  )
}

export default QrcodeWithTemplate
